import types from '../actions/nav/types';

const initialState = {
  mainNav: [],
  secondNav: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.GET_NAV:
      return { ...state, mainNav: [], secondNav: [] };
    case types.GET_NAV_SUCCESS:
      return {
        ...state,
        mainNav: action.payload.mainNav,
        secondNav: action.payload.secondNav,
      };
    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/app/reducers/nav.js